export const sancionadosData = [
  {
    "numero": "1",
    "servidorPublico": "C. Luis Elias resendiz Sanchez",
    "dependencia": "Ayuntamiento  de tizayuca",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/51/2022",
    "autoridadSancionadora": "Autoridad Resolutora de la Contraloría Municipal de Tizayuca",
    "fechaResolucion": "2023-01-12 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "2",
    "servidorPublico": "C. Jair de Jesus Avila Chavez",
    "dependencia": "Ayuntamiento  de tizayuca",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/52/2022",
    "autoridadSancionadora": "Autoridad Resolutora de la Contraloría Municipal de Tizayuca",
    "fechaResolucion": "2023-01-12 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "3",
    "servidorPublico": "C. Cristian Santillan Flores",
    "dependencia": "Ayuntamiento  de tizayuca",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/53/2022",
    "autoridadSancionadora": "Autoridad Resolutora de la Contraloría Municipal de Tizayuca",
    "fechaResolucion": "2023-01-12 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "4",
    "servidorPublico": "C. Jose Luis Hernandez Camacho",
    "dependencia": "Ayuntamiento  de tizayuca",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/53/2022",
    "autoridadSancionadora": "Autoridad Resolutora de la Contraloría Municipal de Tizayuca",
    "fechaResolucion": "2023-01-12 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "5",
    "servidorPublico": "Edna Lorena Ocaña Jimenez",
    "dependencia": "AUTORIDAD RESOLUTORA DE LA SECRETARÍA DE CONTRALORÍA INTERNA DEL MUNICIPIO DE TIZAYUCA, ESTADO DE HIDALGO",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/12/2023",
    "autoridadSancionadora": "Contraloría Interna Municipal",
    "fechaResolucion": "2023-06-06 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "6",
    "servidorPublico": "Nancy Margarita Fernández Rivero",
    "dependencia": "AUTORIDAD RESOLUTORA DE LA SECRETARÍA DE CONTRALORÍA INTERNA DEL MUNICIPIO DE TIZAYUCA, ESTADO DE HIDALGO",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/10/2023",
    "autoridadSancionadora": "Contraloría Interna Municipal",
    "fechaResolucion": "2023-06-06 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "7",
    "servidorPublico": "Odon Jacinto Pavón Rodriguez",
    "dependencia": "AUTORIDAD RESOLUTORA DE LA SECRETARÍA DE CONTRALORÍA INTERNA DEL MUNICIPIO DE TIZAYUCA, ESTADO DE HIDALGO",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/08/2023",
    "autoridadSancionadora": "Contraloría Interna Municipal",
    "fechaResolucion": "2023-06-06 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "8",
    "servidorPublico": "Manuel Sanchez Martinez",
    "dependencia": "AUTORIDAD RESOLUTORA DE LA SECRETARÍA DE CONTRALORÍA INTERNA DEL MUNICIPIO DE TIZAYUCA, ESTADO DE HIDALGO",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/14/2023",
    "autoridadSancionadora": "Contraloría Interna Municipal",
    "fechaResolucion": "2023-06-06 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "9",
    "servidorPublico": "Brigido Manuel Cruz Peña",
    "dependencia": "AUTORIDAD RESOLUTORA DE LA SECRETARÍA DE CONTRALORÍA INTERNA DEL MUNICIPIO DE TIZAYUCA, ESTADO DE HIDALGO",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/17/2024",
    "autoridadSancionadora": "Contraloría Interna Municipal",
    "fechaResolucion": "2023-06-06 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "10",
    "servidorPublico": "Rodolfo Pérez Leyva",
    "dependencia": "AUTORIDAD RESOLUTORA DE LA SECRETARÍA DE CONTRALORÍA INTERNA DEL MUNICIPIO DE TIZAYUCA, ESTADO DE HIDALGO",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/15/2023",
    "autoridadSancionadora": "Contraloría Interna Municipal",
    "fechaResolucion": "2023-06-06 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "11",
    "servidorPublico": "Tais America Olvera Ramos",
    "dependencia": "AUTORIDAD RESOLUTORA DE LA SECRETARÍA DE CONTRALORÍA INTERNA DEL MUNICIPIO DE TIZAYUCA, ESTADO DE HIDALGO",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/13/2023",
    "autoridadSancionadora": "Contraloría Interna Municipal",
    "fechaResolucion": "2023-06-06 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "12",
    "servidorPublico": "Mitzi Estefani Medina Sánchez",
    "dependencia": "AUTORIDAD RESOLUTORA DE LA SECRETARÍA DE CONTRALORÍA INTERNA DEL MUNICIPIO DE TIZAYUCA, ESTADO DE HIDALGO",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/07/2023",
    "autoridadSancionadora": "Contraloría Interna Municipal",
    "fechaResolucion": "2023-06-05 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "13",
    "servidorPublico": "Nicolasa Corona Aguilarnicolasa Corona Aguilar",
    "dependencia": "AUTORIDAD RESOLUTORA DE LA SECRETARÍA DE CONTRALORÍA INTERNA DEL MUNICIPIO DE TIZAYUCA, ESTADO DE HIDALGO",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/04/2023",
    "autoridadSancionadora": "Contraloría Interna Municipal",
    "fechaResolucion": "2023-06-05 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "14",
    "servidorPublico": "Jair Aviezer Diaz Martinez",
    "dependencia": "AUTORIDAD RESOLUTORA DE LA SECRETARÍA DE CONTRALORÍA INTERNA DEL MUNICIPIO DE TIZAYUCA, ESTADO DE HIDALGO",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/03/2023",
    "autoridadSancionadora": "Contraloría Interna Municipal",
    "fechaResolucion": "2023-06-26 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "15",
    "servidorPublico": "Socorro Rodriguez Sanchez",
    "dependencia": "AUTORIDAD RESOLUTORA DE LA SECRETARÍA DE CONTRALORÍA INTERNA DEL MUNICIPIO DE TIZAYUCA, ESTADO DE HIDALGO",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/21/2023",
    "autoridadSancionadora": "Contraloría Interna Municipal",
    "fechaResolucion": "2023-08-16 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "16",
    "servidorPublico": "Olga Susana Aguilar Pioquinto",
    "dependencia": "AUTORIDAD RESOLUTORA DE LA SECRETARÍA DE CONTRALORÍA INTERNA DEL MUNICIPIO DE TIZAYUCA, ESTADO DE HIDALGO",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/20/2023",
    "autoridadSancionadora": "Contraloría Interna Municipal",
    "fechaResolucion": "2023-08-16 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "17",
    "servidorPublico": "Marivel Corona Mendoza",
    "dependencia": "AUTORIDAD RESOLUTORA DE LA SECRETARÍA DE CONTRALORÍA INTERNA DEL MUNICIPIO DE TIZAYUCA, ESTADO DE HIDALGO",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/19/2023",
    "autoridadSancionadora": "Contraloría Interna Municipal",
    "fechaResolucion": "2023-08-16 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "18",
    "servidorPublico": "Livier Neri De León",
    "dependencia": "Colegio de Estudios Científicos y Tecnológicos del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "PRA/37/2023",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloria",
    "fechaResolucion": "2023-07-24 00:00:00",
    "causaSancion": "OMISION A LA DECLARACION DE SITUACION PATRIMONIAL DE MODIFICACION",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "19",
    "servidorPublico": "Luis Erick Ramirez Castro",
    "dependencia": "AUTORIDAD RESOLUTORA DE LA SECRETARÍA DE CONTRALORÍA INTERNA DEL MUNICIPIO DE TIZAYUCA, ESTADO DE HIDALGO",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/28/2023",
    "autoridadSancionadora": "Contraloría Interna Municipal",
    "fechaResolucion": "2023-09-27 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "20",
    "servidorPublico": "Antonio Meneses Davalos",
    "dependencia": "AUTORIDAD RESOLUTORA DE LA SECRETARÍA DE CONTRALORÍA INTERNA DEL MUNICIPIO DE TIZAYUCA, ESTADO DE HIDALGO",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/26/2023",
    "autoridadSancionadora": "Contraloría Interna Municipal",
    "fechaResolucion": "2023-09-27 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "21",
    "servidorPublico": "Miguel Agustin Alva Rangel",
    "dependencia": "AUTORIDAD RESOLUTORA DE LA SECRETARÍA DE CONTRALORÍA INTERNA DEL MUNICIPIO DE TIZAYUCA, ESTADO DE HIDALGO",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/25/2023",
    "autoridadSancionadora": "Contraloría Interna Municipal",
    "fechaResolucion": "2023-09-27 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "22",
    "servidorPublico": "Felipe De Jesus Gonzalez Garcia",
    "dependencia": "AUTORIDAD RESOLUTORA DE LA SECRETARÍA DE CONTRALORÍA INTERNA DEL MUNICIPIO DE TIZAYUCA, ESTADO DE HIDALGO",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/30/2023",
    "autoridadSancionadora": "Contraloría Interna Municipal",
    "fechaResolucion": "2023-09-27 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "23",
    "servidorPublico": "Laura Edith Gutierrez Pineda",
    "dependencia": "AUTORIDAD RESOLUTORA DE LA SECRETARÍA DE CONTRALORÍA INTERNA DEL MUNICIPIO DE TIZAYUCA, ESTADO DE HIDALGO",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/29/2023",
    "autoridadSancionadora": "Contraloría Interna Municipal",
    "fechaResolucion": "2023-09-27 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "24",
    "servidorPublico": "Hilario Perez Hernandez",
    "dependencia": "AUTORIDAD RESOLUTORA DE LA SECRETARÍA DE CONTRALORÍA INTERNA DEL MUNICIPIO DE TIZAYUCA, ESTADO DE HIDALGO",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/27/2023",
    "autoridadSancionadora": "Contraloría Interna Municipal",
    "fechaResolucion": "2023-09-27 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "25",
    "servidorPublico": "Diana Lizbeth Garcia Ceron",
    "dependencia": "AUTORIDAD RESOLUTORA DE LA SECRETARÍA DE CONTRALORÍA INTERNA DEL MUNICIPIO DE TIZAYUCA, ESTADO DE HIDALGO",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/31/2023",
    "autoridadSancionadora": "Contraloría Interna Municipal",
    "fechaResolucion": "2023-09-27 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "26",
    "servidorPublico": "Enrique Tellez Paredes",
    "dependencia": "Secretaría de Salud y Servicios de Salud de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "PRA/134/2022",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloria",
    "fechaResolucion": "2023-10-11 00:00:00",
    "causaSancion": "Omisión en presentar en tiempo y forma la Declaración de Situación Patrimonial de Modificación del ejercicio 2020",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "27",
    "servidorPublico": "Rey Bernardo Gutierrez Mendez",
    "dependencia": "Secretaría de Salud y Servicios de Salud de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "PRA/135/2022",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloria",
    "fechaResolucion": "2023-10-12 00:00:00",
    "causaSancion": "Omisión en presentar en tiempo y forma la Declaración de Situación Patrimonial de Modificación del ejercicio 2021",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "28",
    "servidorPublico": "Nancy Karina Ceron",
    "dependencia": "Secretaría de Salud y Servicios de Salud de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "PRA/158/2022",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloria",
    "fechaResolucion": "2023-10-13 00:00:00",
    "causaSancion": "Omisión en presentar en tiempo y forma la Declaración de Situación Patrimonial de Modificación del ejercicio 2020",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "29",
    "servidorPublico": "Francisco Morales Martinez",
    "dependencia": "Secretaría de Salud y Servicios de Salud de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "PRA/196/2022",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloria",
    "fechaResolucion": "2023-10-10 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Conclusión de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "30",
    "servidorPublico": "Gloria Salas Colunga",
    "dependencia": "Secretaría de Salud y Servicios de Salud de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "PRA/200/2022",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloria",
    "fechaResolucion": "2023-10-17 00:00:00",
    "causaSancion": "Omisión en presentar en tiempo y forma la Declaración de Situación Patrimonial de Modificación del ejercicio 2021",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "31",
    "servidorPublico": "Eliel Ordaz Rivera",
    "dependencia": "Secretaría de Salud y Servicios de Salud de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "PRA/201/2022",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloria",
    "fechaResolucion": "2023-10-10 00:00:00",
    "causaSancion": "Omisión en presentar en tiempo y forma la Declaración de Situación Patrimonial de Modificación del ejercicio 2021",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "32",
    "servidorPublico": "Maria De Lourdes Perla Garcia",
    "dependencia": "Secretaría de Salud y Servicios de Salud de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "PRA/203/2022",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloria",
    "fechaResolucion": "2023-10-10 00:00:00",
    "causaSancion": "Omisión en presentar en tiempo y forma la Declaración de Situación Patrimonial de Modificación del ejercicio 2021",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "33",
    "servidorPublico": "Daniela Elizabeth Sanchez Bautista",
    "dependencia": "Secretaría de Salud y Servicios de Salud de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "PRA/204/2022",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloria",
    "fechaResolucion": "2023-10-11 00:00:00",
    "causaSancion": "Omisión en presentar en tiempo y forma la Declaración de Situación Patrimonial de Modificación del ejercicio 2021",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "34",
    "servidorPublico": "Edwin Tovar Vigueras",
    "dependencia": "Secretaría de Salud y Servicios de Salud de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "PRA/224/2022",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloria",
    "fechaResolucion": "2023-10-18 00:00:00",
    "causaSancion": "Omisión en presentar en tiempo y forma la Declaración de Situación Patrimonial de Modificación del ejercicio 2020",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "35",
    "servidorPublico": "Denisse Harlet Hernandez Monroy",
    "dependencia": "Secretaría de Salud y Servicios de Salud de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "PRA/225/2022",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloria",
    "fechaResolucion": "2023-10-12 00:00:00",
    "causaSancion": "Omisión en presentar en tiempo y forma la Declaración de Situación Patrimonial de Modificación del ejercicio 2021",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "36",
    "servidorPublico": "Martha Elba Flores Santana",
    "dependencia": "Presidencia Municipal de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/34/2023",
    "autoridadSancionadora": "Contraloría Interna Municipal",
    "fechaResolucion": "2023-10-23 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "37",
    "servidorPublico": "Roberto Hernández García",
    "dependencia": "Secretaría de Salud y Servicios de Salud de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "PRA/185/2022",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloria",
    "fechaResolucion": "2023-10-11 00:00:00",
    "causaSancion": "Omisión en presentar en tiempo y forma la Declaración de Situación Patrimonial de Modificación del ejercicio 2020",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "38",
    "servidorPublico": "Edmundo Gutiérrez Rodríguez",
    "dependencia": "Presidencia Municipal de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/43/2023",
    "autoridadSancionadora": "Contraloría Interna Municipal",
    "fechaResolucion": "2023-11-22 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "39",
    "servidorPublico": "Cristina Ortíz Hernández",
    "dependencia": "Presidencia Municipal de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/45/2023",
    "autoridadSancionadora": "Contraloría Interna Municipal",
    "fechaResolucion": "2023-11-24 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "40",
    "servidorPublico": "Monica Mendoza García",
    "dependencia": "Presidencia Municipal de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/53/2023",
    "autoridadSancionadora": "Contraloría Interna Municipal",
    "fechaResolucion": "2023-12-12 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Conclusión de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "41",
    "servidorPublico": "Miguel Cordóba Martínez",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2022/02",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-08-08 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "42",
    "servidorPublico": "Oscar Moya Luna",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2022/10",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-12-07 00:00:00",
    "causaSancion": "Omisión en presentar en tiempo y forma la Declaración de Situación Patrimonial de Modificación del ejercicio 2021",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "43",
    "servidorPublico": "Fernando Rodríguez Hernández",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2022/03",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-08-07 00:00:00",
    "causaSancion": "Omisión en presentar en tiempo y forma la Declaración de Situación Patrimonial de Modificación del ejercicio 2021",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "44",
    "servidorPublico": "Oscar González Sierra",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2023/18",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-08-01 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Conclusión de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "45",
    "servidorPublico": "Miguel Ángel Reséndiz Sánchez",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2023/20",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-08-14 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "46",
    "servidorPublico": "Féliz Urrea Ovando",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2022/04",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-07-03 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "47",
    "servidorPublico": "José Bautista Torres",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2022/11",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-06-30 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la Declaración de Situación Patrimonial de Modificación del ejercicio 2021",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "48",
    "servidorPublico": "Yesica Nereida Vázquez Gutiérrez",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2022/48",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-07-25 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Conclusión de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "49",
    "servidorPublico": "Antonio Pineda Reyes",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2022/06",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-07-28 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "50",
    "servidorPublico": "Marcos Aurelio Nanco Ángeles",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2023/15",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-08-18 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "51",
    "servidorPublico": "Lucila Olvera Jacinto",
    "dependencia": "Secretaría de Salud y Servicios de Salud de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "PRA/16/2023",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloria",
    "fechaResolucion": "2023-12-10 00:00:00",
    "causaSancion": "Omisión en presentar en tiempo y forma la Declaración de Situación Patrimonial de Modificación del ejercicio 2021",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "52",
    "servidorPublico": "Heriberto Martínez Méndez",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2022/17",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-10-10 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Modificación",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "53",
    "servidorPublico": "Arturo García Islas",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2023/06",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-08-31 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "54",
    "servidorPublico": "Eduardo Aparicio Corchado",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2022/14",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-07-31 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "55",
    "servidorPublico": "Jared Jesús Segura Carbajal",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2022/05",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-10-10 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "56",
    "servidorPublico": "Salvador Ismael Díaz García",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2023/19",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-08-17 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "57",
    "servidorPublico": "Juan Miguel Jiménez Montaño",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2022/22",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-11-27 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "58",
    "servidorPublico": "Germán Hernández Baltazar",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2022/34",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-09-19 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Modificación",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "59",
    "servidorPublico": "Felipe Neri Hernández Gutierrez",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2022/07",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-07-06 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "60",
    "servidorPublico": "Josue Francisco Martínez Martínez",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2023/16",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-08-31 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "61",
    "servidorPublico": "Jorge Parrales Muñoz",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2022/08",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-08-08 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "62",
    "servidorPublico": "Dulce Celina Cervantes Flores",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2022/08",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-07-04 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "63",
    "servidorPublico": "Rafael Rodríguez Rivas",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2023/17",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-08-17 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "64",
    "servidorPublico": "Minerva Miranda Castro Juarez",
    "dependencia": "Secretaría de Educación Pública de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC-DGRA-DR-2023/PRA012",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloria",
    "fechaResolucion": "2024-01-08 00:00:00",
    "causaSancion": "Omisión en presentar en tiempo y forma la Declaración de Situación Patrimonial de Modificación del ejercicio 2019",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "65",
    "servidorPublico": "Teresita De Jesus Calderon Perez",
    "dependencia": "Secretaría de Educación Pública de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC-DGRA-DR-2023/PRA015",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloria",
    "fechaResolucion": "2024-01-08 00:00:00",
    "causaSancion": "Omisión en presentar en tiempo y forma la Declaración de Situación Patrimonial de Modificación del ejercicio 2019",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "66",
    "servidorPublico": "Guadalupe Ramírez Salzar",
    "dependencia": "Presidencia Municipal de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/47/2023",
    "autoridadSancionadora": "Autoridad Resolutora de la Secretaría de Contraloría Interna del Municipio de Tizayuca, Estado de Hidalgo",
    "fechaResolucion": "2023-12-12 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "67",
    "servidorPublico": "David Vázquez Quiroz",
    "dependencia": "Presidencia Municipal de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/44/2023",
    "autoridadSancionadora": "Autoridad Resolutora de la Secretaría de Contraloría Interna del Municipio de Tizayuca, Estado de Hidalgo",
    "fechaResolucion": "2023-11-24 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "68",
    "servidorPublico": "Pedro Ramírez Rivera",
    "dependencia": "Presidencia Municipal de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/59/2023",
    "autoridadSancionadora": "Autoridad Resolutora de la Secretaría de Contraloría Interna del Municipio de Tizayuca, Estado de Hidalgo",
    "fechaResolucion": "2023-12-20 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Conclusión de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "69",
    "servidorPublico": "Carlos Daniel Pineda Albor",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2022/20",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-09-26 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "70",
    "servidorPublico": "Melitón Alejandre Cruz",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2022/30",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-10-03 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Conclusión de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "71",
    "servidorPublico": "Salvador Pedro Solís Maldonado",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2022/35",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-07-29 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Conclusión de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "72",
    "servidorPublico": "María Isabel Cuellar Chávez",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2021/12",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-07-26 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Conclusión de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "73",
    "servidorPublico": "Orlando Cerón Almaraz",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2023/24",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-09-19 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Conclusión de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "74",
    "servidorPublico": "José De Jesús Gómez García",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2021/07",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-07-28 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Conclusión de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "75",
    "servidorPublico": "Héctor Rodrigo Alejandre Vargas",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2022/32",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-09-29 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Conclusión de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "76",
    "servidorPublico": "Karen Isabel Agullón García",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2023/25",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-09-29 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Conclusión de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "77",
    "servidorPublico": "Onesimo Israel Quezada Quezada",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2022/50",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-07-25 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Conclusión de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "78",
    "servidorPublico": "Raúl Alfonso Caballero Contreras",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2021/06",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-10-04 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Conclusión de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "79",
    "servidorPublico": "Mario Queijeiro Rojas",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2022/37",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-11-27 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "80",
    "servidorPublico": "Lucia Ávila Fuentes",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2022/26",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-10-19 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Conclusión de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "81",
    "servidorPublico": "Yaquelin Quezada Pérez",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2023/39",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-10-23 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "82",
    "servidorPublico": "Karina Hernández Ponce",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2021/13",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-08-08 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Conclusión de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "83",
    "servidorPublico": "Paola Cervantes Ortega",
    "dependencia": "Secretaría de Educación Pública de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "PRA/095/2022",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloria",
    "fechaResolucion": "2024-02-15 00:00:00",
    "causaSancion": "Omisión en presentar en tiempo y forma la Declaración de Situación Patrimonial de Modificación del ejercicio 2019",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "84",
    "servidorPublico": "Cesar Augusto Cespedes Badillo",
    "dependencia": "Secretaría de Educación Pública de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGCI/DR/2023/PRA033",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloria",
    "fechaResolucion": "2024-02-08 00:00:00",
    "causaSancion": "Omisión en presentar en tiempo y forma la Declaración de Situación Patrimonial de Modificación del ejercicio 2019",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "85",
    "servidorPublico": "Norma Lidia Rojas López",
    "dependencia": "Secretaría de Educación Pública de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGCI/DR/2023/PRA035",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloria",
    "fechaResolucion": "2024-02-12 00:00:00",
    "causaSancion": "Omisión en presentar en tiempo y forma la Declaración de Situación Patrimonial de Modificación del ejercicio 2019",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "86",
    "servidorPublico": "Hugo Juárez Cervantes",
    "dependencia": "Presidencia Municipal de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/33/2023",
    "autoridadSancionadora": "Autoridad Resolutora de la Secretaría de Contraloría Interna del Municipio de Tizayuca, Estado de Hidalgo",
    "fechaResolucion": "2023-12-29 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "87",
    "servidorPublico": "Jaciel Vargas García",
    "dependencia": "Presidencia Municipal de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/01/2024",
    "autoridadSancionadora": "Autoridad Resolutora de la Secretaría de Contraloría Interna del Municipio de Tizayuca, Estado de Hidalgo",
    "fechaResolucion": "2024-01-25 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Conclusión de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "88",
    "servidorPublico": "Juan Ignacio Ramírez Rivera",
    "dependencia": "Presidencia Municipal de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/02/2024",
    "autoridadSancionadora": "Autoridad Resolutora de la Secretaría de Contraloría Interna del Municipio de Tizayuca, Estado de Hidalgo",
    "fechaResolucion": "2024-01-25 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Conclusión de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "89",
    "servidorPublico": "Humberto Vizueto López",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2022/01",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-10-02 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "90",
    "servidorPublico": "Vianey Escalante Garnica",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2022/24",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-09-20 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Conclusión de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "91",
    "servidorPublico": "Juan Manuel Lira Gómez",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2022/31",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-11-22 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "92",
    "servidorPublico": "Jorge Alberto Rodríguez Martínez",
    "dependencia": "Presidencia Municipal de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/32/2023",
    "autoridadSancionadora": "Autoridad Resolutora de la Secretaría de Contraloría Interna del Municipio de Tizayuca, Estado de Hidalgo",
    "fechaResolucion": "2023-10-23 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "93",
    "servidorPublico": "Yeniza Sarahi Montoya Martínez",
    "dependencia": "Secretaría de Educación Pública de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "PRA/107/2022",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloria",
    "fechaResolucion": "2022-08-04 00:00:00",
    "causaSancion": "Omisión en el cumplimiento de funciones y atribuciones encomendadas",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "94",
    "servidorPublico": "Edgar Meneses Dávila",
    "dependencia": "Secretaría de Educación Pública de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "PRA/112/2022",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloria",
    "fechaResolucion": "2024-02-14 00:00:00",
    "causaSancion": "Omisión en presentar en tiempo y forma la Declaración de Situación Patrimonial de Modificación del ejercicio 2019",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "95",
    "servidorPublico": "Noé Abelino Cano León",
    "dependencia": "Secretaría de Educación Pública de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "PRA/106/2022",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloria",
    "fechaResolucion": "2022-08-01 00:00:00",
    "causaSancion": "Omiso en el cumplimiento de funciones y atribuciones encomendadas",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "96",
    "servidorPublico": "Juan José Pérez Luna",
    "dependencia": "Secretaría de Educación Pública de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "PRA/105/2022",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloria",
    "fechaResolucion": "2022-08-01 00:00:00",
    "causaSancion": "Omiso en el cumplimiento de funciones y atribuciones encomendadas",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "97",
    "servidorPublico": "José  Luis Ramírez Hernández",
    "dependencia": "Secretaría de Educación Pública de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "PRA/100/2022",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloria",
    "fechaResolucion": "2022-09-21 00:00:00",
    "causaSancion": "Omisión en presentar en tiempo y forma la Declaración de Situación Patrimonial de Inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "98",
    "servidorPublico": "Estefanía Gayosso Mejía",
    "dependencia": "Secretaría de Salud y Servicios de Salud de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "PRA/205/2022",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloria",
    "fechaResolucion": "2024-03-04 00:00:00",
    "causaSancion": "Omisión en presentar en tiempo y forma la Declaración de Situación Patrimonial de Conclusión",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "99",
    "servidorPublico": "Pedro Eduardo Vázquez Martínez",
    "dependencia": "Secretaría de Educación Pública de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "PRA/030/2022",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloria",
    "fechaResolucion": "2024-02-15 00:00:00",
    "causaSancion": "Omisión en presentar en tiempo y forma la Declaración de Situación Patrimonial de Modificación del ejercicio 2019",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "100",
    "servidorPublico": "Daniel Aureliano Ramírez Hernández",
    "dependencia": "Secretaría de Salud y Servicios de Salud de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "PRA/206/2022",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloria",
    "fechaResolucion": "2024-03-15 00:00:00",
    "causaSancion": "Omisión en presentar en tiempo y forma la Declaración de Situación Patrimonial de Conclusión",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "101",
    "servidorPublico": "Fernando Lechuga Flores",
    "dependencia": "Presidencia Municipal de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/04/2024",
    "autoridadSancionadora": "Autoridad Resolutora de la Secretaría de Contraloría Interna del Municipio de Tizayuca, Estado de Hidalgo",
    "fechaResolucion": "2024-03-19 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de conclusión",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "102",
    "servidorPublico": "Juan Lara Ramírez",
    "dependencia": "Presidencia Municipal de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/15/2024",
    "autoridadSancionadora": "Autoridad Resolutora de la Secretaría de Contraloría Interna del Municipio de Tizayuca, Estado de Hidalgo",
    "fechaResolucion": "2024-05-06 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "103",
    "servidorPublico": "Héctor Bobadilla Cabrera",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2023/44",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2024-03-05 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio y Conclusion de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "104",
    "servidorPublico": "José Nicolás  Granados  Flores",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2023/43",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2024-03-06 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "105",
    "servidorPublico": "Pedro Tapia Blancas",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2022/38",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2024-03-05 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "106",
    "servidorPublico": "David Pérez Pérez",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2023/01",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2024-03-05 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "107",
    "servidorPublico": "José Felix Hernández  Hernández",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2022/13",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2024-03-05 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "108",
    "servidorPublico": "Marisol Ascencio  Montesinos",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2022/39",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-10-20 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Conclusion de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "109",
    "servidorPublico": "Evelyn Viridiana Aguilar Quezada",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2023/52",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2024-01-15 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "110",
    "servidorPublico": "Marycarmen Pérez Correa",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2021/11",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-07-28 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Conclusion de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "111",
    "servidorPublico": "Edgar Francisco Estrada Castro",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2022/40",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2023-09-19 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Modificación de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "112",
    "servidorPublico": "Miguel Yunel Rojas Flores",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2023/21",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2024-03-13 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Conclusion de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "113",
    "servidorPublico": "Analet Pérez Fernández",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2023/03",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2024-05-21 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Conclusion de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "114",
    "servidorPublico": "José Alejandro Cabrera Guerrera",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2023/54",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2024-05-21 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "115",
    "servidorPublico": "Liliana Pérez Peña",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2023/33",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2024-05-21 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "116",
    "servidorPublico": "Aldo Sebastian Luna Córdova",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2023/055",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2024-05-21 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Conclusion de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "117",
    "servidorPublico": "Dafne Legaria Ramírez",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2023/04",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2024-05-28 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Conclusion de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "118",
    "servidorPublico": "Luis Fernando Ramírez Valentin",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2023/32",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2024-05-28 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Conclusion de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "119",
    "servidorPublico": "Yair Ismael Lara Abrego",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2022/52",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2024-05-28 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "120",
    "servidorPublico": "Eduardo Guzmán López",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2023/10",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2024-05-28 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "121",
    "servidorPublico": "Brigido Melquiades Avila Martínez",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2022/46",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2024-05-27 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Conclusion de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "122",
    "servidorPublico": "José  Antonio Cruz Quezada",
    "dependencia": "Comision de Agua y Alcantarillado del Municipio de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-CAAMTH/RES/2023/47",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control",
    "fechaResolucion": "2024-05-27 00:00:00",
    "causaSancion": "Omisión a la Declaración de Situación Patrimonial de Inicio de Cargo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "123",
    "servidorPublico": "Arturo Hernández de la Cruz",
    "dependencia": "Presidencia Municipal de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/16/2024",
    "autoridadSancionadora": "Autoridad Resolutora de la Secretaría de Contraloría Interna del Municipio de Tizayuca, Estado de Hidalgo",
    "fechaResolucion": "2024-05-06 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "124",
    "servidorPublico": "Manuel Rosales Noriega",
    "dependencia": "Presidencia Municipal de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/17/2024",
    "autoridadSancionadora": "Autoridad Resolutora de la Secretaría de Contraloría Interna del Municipio de Tizayuca, Estado de Hidalgo",
    "fechaResolucion": "2024-05-06 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "125",
    "servidorPublico": "Yenny Castro Rodríguez",
    "dependencia": "Presidencia Municipal de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/19/2024",
    "autoridadSancionadora": "Autoridad Resolutora de la Secretaría de Contraloría Interna del Municipio de Tizayuca, Estado de Hidalgo",
    "fechaResolucion": "2024-06-24 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "126",
    "servidorPublico": "Diana Elisa Cuevas Otero",
    "dependencia": "Presidencia Municipal de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/20/2024",
    "autoridadSancionadora": "Autoridad Resolutora de la Secretaría de Contraloría Interna del Municipio de Tizayuca, Estado de Hidalgo",
    "fechaResolucion": "2024-06-26 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "127",
    "servidorPublico": "Gamaliel García Reyes",
    "dependencia": "Presidencia Municipal de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/26/2024",
    "autoridadSancionadora": "Autoridad Resolutora de la Secretaría de Contraloría Interna del Municipio de Tizayuca, Estado de Hidalgo",
    "fechaResolucion": "2024-07-16 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "128",
    "servidorPublico": "Selene Zamora Ortíz",
    "dependencia": "Presidencia Municipal de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/21/2024",
    "autoridadSancionadora": "Autoridad Resolutora de la Secretaría de Contraloría Interna del Municipio de Tizayuca, Estado de Hidalgo",
    "fechaResolucion": "2024-07-02 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "129",
    "servidorPublico": "Abundio Ernesto Ángeles González",
    "dependencia": "Presidencia Municipal de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/24/2024",
    "autoridadSancionadora": "Autoridad Resolutora de la Secretaría de Contraloría Interna del Municipio de Tizayuca, Estado de Hidalgo",
    "fechaResolucion": "2024-07-15 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "130",
    "servidorPublico": "Ángel Agustín Godínez Vázquez",
    "dependencia": "Presidencia Municipal de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/27/2024",
    "autoridadSancionadora": "Autoridad Resolutora de la Secretaría de Contraloría Interna del Municipio de Tizayuca, Estado de Hidalgo",
    "fechaResolucion": "2024-07-17 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "131",
    "servidorPublico": "Jorge Javier Paniagua Rangel",
    "dependencia": "Presidencia Municipal de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/30/2024",
    "autoridadSancionadora": "Autoridad Resolutora de la Secretaría de Contraloría Interna del Municipio de Tizayuca, Estado de Hidalgo",
    "fechaResolucion": "2024-07-24 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "132",
    "servidorPublico": "Monica Anahi Martinez Gomez",
    "dependencia": "Presidencia Municipal de Ixmiquilpan, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "IXMI/AR/PRA/003/2024",
    "autoridadSancionadora": "Autoridad Resolutora de la Presidencia Municipal de Ixmiquilpan",
    "fechaResolucion": "2024-08-18 00:00:00",
    "causaSancion": "Negligencia Administrativa",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "133",
    "servidorPublico": "Cristina Barragan Diaz",
    "dependencia": "Presidencia Municipal de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/29/2024",
    "autoridadSancionadora": "Autoridad Resolutora de la Secretaría de Contraloría Interna del Municipio de Tizayuca, Estado de Hidalgo",
    "fechaResolucion": "2024-07-24 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "134",
    "servidorPublico": "Lizette Magali Marquez Arreguin",
    "dependencia": "Presidencia Municipal de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/31/2024",
    "autoridadSancionadora": "Autoridad Resolutora de la Secretaría de Contraloría Interna del Municipio de Tizayuca, Estado de Hidalgo",
    "fechaResolucion": "2024-07-26 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "135",
    "servidorPublico": "Nalleli Romero Amador",
    "dependencia": "CENTRO DE JUSTICIA PARA MUJERES DEL ESTADO DE HIDALGO",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA028",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2024-06-21 00:00:00",
    "causaSancion": "Omitió presentar su declaración de Situación Patrimonial de Conclusión",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "136",
    "servidorPublico": "María Magdalena Jaime Arroyo",
    "dependencia": "CENTRO DE JUSTICIA PARA MUJERES DEL ESTADO DE HIDALGO",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA025",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2024-06-07 00:00:00",
    "causaSancion": "Omitió presentar su declaración de Situación Patrimonial de Conclusión",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "137",
    "servidorPublico": "Circe Jeannett Ayala Luis",
    "dependencia": "INSTITUTO TECNOLOGICO SUPERIOR DE HUICHAPAN",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA044",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2024-06-14 00:00:00",
    "causaSancion": "Omitió presentar su declaración de Situación Patrimonial de Conclusión",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "138",
    "servidorPublico": "Grissel Rosales Díaz",
    "dependencia": "Colegio de Bachilleres del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "CI/COBAEH/PRA/001/2015",
    "autoridadSancionadora": "Órgano Interno de Control del Colegio de BBachilleres del Estado de Hidalgo",
    "fechaResolucion": "2024-06-26 00:00:00",
    "causaSancion": "Incumplimiento de funciones",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "139",
    "servidorPublico": "Fernando Vargas Bacilio",
    "dependencia": "Tizayuca",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/46/2024",
    "autoridadSancionadora": "Autoridad Resolutora de Tizayuca",
    "fechaResolucion": "2024-11-13 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "140",
    "servidorPublico": "Zenón Meza Zumuya",
    "dependencia": "Tizayuca",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/47/2024",
    "autoridadSancionadora": "Autoridad Resolutora de Tizayuca",
    "fechaResolucion": "2024-11-13 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "141",
    "servidorPublico": "Oscar Jahir Rivera Pérez",
    "dependencia": "Tizayuca",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/45/2024",
    "autoridadSancionadora": "Autoridad Resolutora de Tizayuca",
    "fechaResolucion": "2024-11-12 00:00:00",
    "causaSancion": "Presentar de manera extemporánea la declaración patrimonial y de intereses en su modalidad de inicio",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "142",
    "servidorPublico": "José Eduardo Cortés Carpio",
    "dependencia": "Servicios de Salud Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "PRA/187/2022",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2024-03-18 00:00:00",
    "causaSancion": "Incumplimiento de funciones",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "143",
    "servidorPublico": "Naim Martínez Salinas",
    "dependencia": "Secretaría de Contraloría y Transparencia del Municipio de Pachuca de Soto",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-PMP/DR/PRA/04/2024",
    "autoridadSancionadora": "Secretaría de Contraloría y Transparencia del Municipio de Pachuca de Soto",
    "fechaResolucion": "2024-11-12 00:00:00",
    "causaSancion": "Incumplimiento de funciones",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "144",
    "servidorPublico": "Luis Alerto Zúñiga Canales",
    "dependencia": "Presidencia Municipal de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/02/2025",
    "autoridadSancionadora": "Autoridad Resolutora de la Secretaría de Contraloría Interna del Municipio de Tizayuca, Estado de Hidalgo",
    "fechaResolucion": "2025-03-07 00:00:00",
    "causaSancion": "Omisión en la Declaración de Situación Patrimonial y de Intereses",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "145",
    "servidorPublico": "Zita Wendy García Pacheco",
    "dependencia": "Presidencia Municipal de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/03/2025",
    "autoridadSancionadora": "Autoridad Resolutora de la Secretaría de Contraloría Interna del Municipio de Tizayuca, Estado de Hidalgo",
    "fechaResolucion": "2025-03-07 00:00:00",
    "causaSancion": "Omisión en la Declaración de Situación Patrimonial y de Intereses",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "146",
    "servidorPublico": "Karen Ortega Ortega",
    "dependencia": "Presidencia Municipal de Tizayuca, Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/01/2025",
    "autoridadSancionadora": "Autoridad Resolutora de la Secretaría de Contraloría Interna del Municipio de Tizayuca, Estado de Hidalgo",
    "fechaResolucion": "2025-03-07 00:00:00",
    "causaSancion": "Omisión en la Declaración de Situación Patrimonial y de Intereses",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "147",
    "servidorPublico": "Alfonso Rico Morales",
    "dependencia": "Dirección de protección civil, bomberos y Gestión Integra de riesgos del Municipio de Pachuca de Soto",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-PMP/DR/PRA/05/2024",
    "autoridadSancionadora": "Secretaría de Contraloría y Transparencia del Municipio de Pachuca de Soto",
    "fechaResolucion": "2025-01-17 00:00:00",
    "causaSancion": "Negligencia Administrativa",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "148",
    "servidorPublico": "Daniel Aurelio Ramírez Hernández",
    "dependencia": "Servicios de Salud Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "PRA/206/2022",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2024-03-15 00:00:00",
    "causaSancion": "Incumplimiento de funciones",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "149",
    "servidorPublico": "María Fernanda Luis Barcena",
    "dependencia": "Secretaría de Bienestar e Inclusión Social",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA185",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-01-14 00:00:00",
    "causaSancion": "Incumplimiento de funciones",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "150",
    "servidorPublico": "Imelda Pérez Espinoza",
    "dependencia": "Instituto Tecnológico Superior de Huichapan",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2023/PRA101",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2024-11-15 00:00:00",
    "causaSancion": "Incumplimiento de funciones",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "151",
    "servidorPublico": "Epigmenio Gabriel González Baños",
    "dependencia": "Secretaría de Infraestructura Pública y Desarrollo Urbano Sostenible del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA117",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-02-18 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "152",
    "servidorPublico": "Francisco Javier Valencia Jiménez",
    "dependencia": "Secretaría de Infraestructura Pública y Desarrollo Urbano Sostenible del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA116",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-02-18 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "153",
    "servidorPublico": "Iván Mariscal Elizalde",
    "dependencia": "Comisión Estatal de Vivienda",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA084",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2024-06-18 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "154",
    "servidorPublico": "Javier Sauza López",
    "dependencia": "Secretaría Ejecutiva de la Política Pública Estatal",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA063",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2024-06-20 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "155",
    "servidorPublico": "Antelma Graciela Ortega Hernández",
    "dependencia": "Secretaría de Bienestar e Inclusión Social",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA208",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-01-14 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "156",
    "servidorPublico": "Marisol García Melo",
    "dependencia": "Colegio de Estudios Cientificos y Tecnologicos del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA226",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-01-14 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "157",
    "servidorPublico": "Juan Romario Hernández Garza",
    "dependencia": "Secretaría Ejecutiva de la Política Pública Estatal",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA015",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2024-09-24 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "158",
    "servidorPublico": "Astrid Marie Chantal Ottoy Fernández",
    "dependencia": "Secretaría de Desarrollo Económico",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA104",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-01-14 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "159",
    "servidorPublico": "Julio César Flores Hernández",
    "dependencia": "Sistema DIF Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA329",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-05-20 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "160",
    "servidorPublico": "Enrique Silva Morales",
    "dependencia": "Secretarái de Educación Pública de Hidalgo y/o Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGCI/DR/2023/PRA028",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-01-14 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "161",
    "servidorPublico": "Juan Carlos Pérez Lozano",
    "dependencia": "Secretaría de Bienestar e Inclusión Social",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA207",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-01-14 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "162",
    "servidorPublico": "Brenda María Hernández Hernández",
    "dependencia": "Universidad Tecnológica de Tulancingo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA223",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-01-14 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "163",
    "servidorPublico": "Alberto Amador Sánchez",
    "dependencia": "Colegio de Estudios Cientificos y Tecnologicos del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA196",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-01-14 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "164",
    "servidorPublico": "Leidy Granados Guillermo",
    "dependencia": "Colegio de Estudios Cientificos y Tecnologicos del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA227",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-02-18 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "165",
    "servidorPublico": "Oscar Munive Valderrama",
    "dependencia": "Servicios de Salud Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "PRA/159/2022",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2024-09-23 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "166",
    "servidorPublico": "Astrid Syomara Hidalgo Ortiz",
    "dependencia": "Centro de Justicia para Mujeres del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA024",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2024-09-24 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "167",
    "servidorPublico": "Pedro Cabrera Vargas",
    "dependencia": "Colegio de Estudios Cientificos y Tecnologicos del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA337",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-02-18 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "168",
    "servidorPublico": "Martín Cristian Cosio Ángeles",
    "dependencia": "Colegio de Estudios Cientificos y Tecnologicos del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA343",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-06-05 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "169",
    "servidorPublico": "Jaime Reyes Nuñez",
    "dependencia": "Secretaría de Infraestructura Pública y Desarrollo Urbano Sostenible del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA366",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-06-05 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "170",
    "servidorPublico": "Antonio Bautista Canales",
    "dependencia": "Secretaría Ejecutiva de la Política Pública Estatal",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA080",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-05-21 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "171",
    "servidorPublico": "Ivan Dalai Reyes Corona",
    "dependencia": "Secretaría de Infraestructura Pública y Desarrollo Urbano Sostenible del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA317",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2024-04-01 00:00:00",
    "causaSancion": "Incumplimiento de funciones",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "172",
    "servidorPublico": "Elizabeth Adriana Flores Torres",
    "dependencia": "Municipio de Pachuca de Soto",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-PMP/DR/PRA/06/2024",
    "autoridadSancionadora": "Autoridad Substanciadora - Resolutora de la Secretaría de Contraloría y Transparencia del Municipio de Pachuca de Soto",
    "fechaResolucion": "2025-07-01 00:00:00",
    "causaSancion": "Negligencia Administrativa",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "173",
    "servidorPublico": "Angel Daniel Nuñez Sauza",
    "dependencia": "Secretaría de Infraestructura Pública y Desarrollo Urbano Sostenible del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA315",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-06-06 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "174",
    "servidorPublico": "Mary Cruz Palacios Vázquez",
    "dependencia": "Servicios de Salud Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-SSH-SSAH/2024/PRA0005",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Órgano Interno de Control en la Secretaría de Salud y los Servicios de Salud de Hidalgo",
    "fechaResolucion": "2024-09-06 00:00:00",
    "causaSancion": "Negligencia Administrativa",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "175",
    "servidorPublico": "Francisco Zamora Cadena",
    "dependencia": "Municipio de Tolcayuca",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "PRA/005/2025",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control de Tolcayuca",
    "fechaResolucion": "2025-08-18 00:00:00",
    "causaSancion": "Negligencia Administrativa",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "176",
    "servidorPublico": "Irene Aurora Fuentes Sánchez",
    "dependencia": "Colegio de Bachilleres del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA276",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-07-07 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "177",
    "servidorPublico": "José Antonio Hernández Cruz",
    "dependencia": "Oficialía Mayor",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA183",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-07-04 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "178",
    "servidorPublico": "Sergio Merced Silva Víveros",
    "dependencia": "Instituto Tecnológico Superior del Occidente del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA194",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-07-04 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "179",
    "servidorPublico": "Reyna Evelyn Cordero Rivera",
    "dependencia": "Universidad Tecnológica de Tulancingo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA322",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-06-05 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "180",
    "servidorPublico": "Juan García Contreras",
    "dependencia": "Colegio de Bachilleres del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA325",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-06-05 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "181",
    "servidorPublico": "Christian Jeovanny Patiño Andrade",
    "dependencia": "Municipio de Tizayuca",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "AR/09/2025",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control del municipio de Tizayuca",
    "fechaResolucion": "2025-10-21 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "182",
    "servidorPublico": "Humberto Martinez Sosa",
    "dependencia": "Sistema DIF Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA046",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-07-01 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "183",
    "servidorPublico": "Macaria Zambrano de Lucio",
    "dependencia": "Sistema DIF Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA356",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-09-23 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "184",
    "servidorPublico": "Dulce María Sandoval Juárez",
    "dependencia": "Municipio de Emiliano Zapata",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "CIM/EZ/013/05/2025",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control Municipal de Emiliano Zapata",
    "fechaResolucion": "2025-10-06 00:00:00",
    "causaSancion": "Incumplimiento de funciones",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "185",
    "servidorPublico": "Adriana Escalante Ponce",
    "dependencia": "Municipio de Tolcayuca",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "PRA/006/2025",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control municipal de Tolcayuca",
    "fechaResolucion": "2025-12-11 00:00:00",
    "causaSancion": "Negligencia Administrativa",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "186",
    "servidorPublico": "Adriana Escalante Ponce",
    "dependencia": "Municipio de Tolcayuca",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "PRA/006/2025",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control municipal de Tolcayuca",
    "fechaResolucion": "2025-12-11 00:00:00",
    "causaSancion": "Negligencia Administrativa",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "187",
    "servidorPublico": "José Godínez López",
    "dependencia": "Secretaría de Hacienda del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA239",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-07-07 00:00:00",
    "causaSancion": "Incumplimiento de funciones",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "188",
    "servidorPublico": "Miguel Ángel Cervantes Bazán",
    "dependencia": "Presidencia Municipal de Emiliano Zapata",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "CIM/EZ/017/06/2025",
    "autoridadSancionadora": "Unidad Resolutora del Órgano Interno de Control del Municipio de Emiliano Zapata, Higalgo",
    "fechaResolucion": "2025-11-10 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "189",
    "servidorPublico": "Juan Miguel Nava Hernández",
    "dependencia": "Comisión de Agua y Alcantarillado de Sistemas Intermunicipales",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA409",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-08-05 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "190",
    "servidorPublico": "Marysther Casasola Carrillo",
    "dependencia": "Colegio de Bachilleres del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA257",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-08-25 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "191",
    "servidorPublico": "Bryan Lugo Cerón",
    "dependencia": "Colegio de Bachilleres del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA259",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-04-15 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "192",
    "servidorPublico": "Leny Selene Batalla Jimenez",
    "dependencia": "Colegio de Bachilleres del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA268",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-03-08 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "193",
    "servidorPublico": "Josue Márquez Hernández",
    "dependencia": "Colegio de Estudios Cientificos y Tecnológicos del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA192",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-08-01 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "194",
    "servidorPublico": "Rosa Alicia Ángeles Hernández",
    "dependencia": "Colegio de Estudios Cientificos y Tecnológicos del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA197",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-07-04 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "195",
    "servidorPublico": "Alvaro Avalos Hernandez",
    "dependencia": "Secretaría de Bienestar e Inclusión Social Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA139",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2024-09-24 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "196",
    "servidorPublico": "José Armando Caballero López",
    "dependencia": "Secretaría de Bienestar e Inclusión Social Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA140",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2024-09-24 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "197",
    "servidorPublico": "Enrique Damian Acuña Ortega",
    "dependencia": "Secretaría de Bienestar e Inclusión Social Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA141",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2024-09-24 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "198",
    "servidorPublico": "Gaudencio Cervantes Cano",
    "dependencia": "Secretaría de Bienestar e Inclusión Social Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA144",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2024-09-24 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "199",
    "servidorPublico": "Luis Raúl Martínez Soto",
    "dependencia": "Secretaría de Bienestar e Inclusión Social Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA160",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-04-08 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "200",
    "servidorPublico": "Johana Vargas Vargas",
    "dependencia": "Secretaría de Bienestar e Inclusión Social Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA203",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-09-01 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "201",
    "servidorPublico": "Clara Torres Olivo",
    "dependencia": "Secretaría de Bienestar e Inclusión Social Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA205",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-07-02 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "202",
    "servidorPublico": "Daniel Alexis Cruz Ornelas",
    "dependencia": "Universidad Tecnológica de Tulancingo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA253",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-08-25 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "203",
    "servidorPublico": "Génesis Aline Mendoza Mentado",
    "dependencia": "Universidad Tecnológica de Tulancingo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA306",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-02-18 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "204",
    "servidorPublico": "Lino Ignacio Ensástiga Contreras",
    "dependencia": "Comisión Estatal del Agua y Alcantarillado",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA456",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-08-01 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "205",
    "servidorPublico": "Aldair Vergara Bartolo",
    "dependencia": "Comisión Estatal del Agua y Alcantarillado",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA492",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-08-01 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "206",
    "servidorPublico": "Ibis Azael Arenas Marín",
    "dependencia": "Universidad Politécnica de Pachuca",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA190",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-11-28 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "207",
    "servidorPublico": "Daniel Pelcastre Sánchez",
    "dependencia": "Secretaría de Infraestructura Pública y Desarrollo Urbano Sostenible del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA235",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-07-02 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "208",
    "servidorPublico": "Adolfo Aldama Barragan",
    "dependencia": "Sistema para el Desarrollo Integral de la Familia del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA328",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-08-07 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "209",
    "servidorPublico": "Miguel Ángel Orozco Castro",
    "dependencia": "Sistema para el Desarrollo Integral de la Familia del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA473",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-08-01 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "210",
    "servidorPublico": "Lucina Rodríguez Monsalvo",
    "dependencia": "Sistema para el Desarrollo Integral de la Familia del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA381",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-08-01 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "211",
    "servidorPublico": "José Oscar Pérez Téllez",
    "dependencia": "Instituto Hidalguense de Educación para Adultos del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA131",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-07-02 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "212",
    "servidorPublico": "María Antonieta Villegas Méndez",
    "dependencia": "Instituto Hidalguense de Educación para Adultos del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA130",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-07-07 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "213",
    "servidorPublico": "Citlaly Vanessa Sánchez Sánchez",
    "dependencia": "Radio y Televisión de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA481",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-11-24 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "214",
    "servidorPublico": "Joel Alberto Carpio Bautista",
    "dependencia": "Radio y Televisión de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA290",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-04-08 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "215",
    "servidorPublico": "María de los Ángeles Redondo Hernández",
    "dependencia": "Colegio de Estudios Cientificos y Tecnológicos del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA403",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-08-05 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "216",
    "servidorPublico": "Zeltzin Arely Hernández Rodarte",
    "dependencia": "Universidad Tecnológica del Valle del Mezquital del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA472",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-10-30 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "217",
    "servidorPublico": "Guillermo Cruz Recendiz",
    "dependencia": "Instituto Tecnológico Superior de Huichapan",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA190",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-07-18 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "218",
    "servidorPublico": "José Salvador Jiménez Azpeitia",
    "dependencia": "Universidad Tecnológica de Mineral de la Reforma del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA098",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-04-28 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "219",
    "servidorPublico": "Frida Muñoz Arévalo",
    "dependencia": "Instituto Tecnológico Superior de Huichapan",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA113",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-02-18 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "220",
    "servidorPublico": "Amado Osorio Pacheco",
    "dependencia": "Sistema para el Desarrollo Integral de la Familia del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA427",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-10-20 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "221",
    "servidorPublico": "Juan Carlos González Cervantes",
    "dependencia": "Sistema para el Desarrollo Integral de la Familia del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA378",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-11-28 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "222",
    "servidorPublico": "Luis Eduardo Coronado Paredes",
    "dependencia": "Comisión Estatal del Agua y Alcantarillado",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA455",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-10-21 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "223",
    "servidorPublico": "Araceli Manriquez Oliver",
    "dependencia": "Secretaría de Desarrollo Económico del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA105",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-04-08 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "224",
    "servidorPublico": "Jorge Armando Luz López",
    "dependencia": "Secretaría de Infraestructura Pública y Desarrollo Urbano Sostenible del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA122",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-02-18 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "225",
    "servidorPublico": "Edson Roberto Pedraza Huerta",
    "dependencia": "Secretaría de Desarrollo Económico del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA106",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-07-04 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "226",
    "servidorPublico": "Elvira Delgadillo Jiménez",
    "dependencia": "Secretaría Ejecutiva de la Política Pública Estatal",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA076",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2024-09-24 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "227",
    "servidorPublico": "Oscar Serratos Vargas",
    "dependencia": "Sistema para el Desarrollo Integral de la Familia del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA480",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-11-24 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "228",
    "servidorPublico": "Cesar Salazar Hernández",
    "dependencia": "Oficialia Mayor",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA240",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-09-02 00:00:00",
    "causaSancion": "Incumplimiento de funciones",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "229",
    "servidorPublico": "Liliam Ernestina Hernández Ordaz",
    "dependencia": "Sistema para el Desarrollo Integral de la Familia del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA292",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-10-10 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "230",
    "servidorPublico": "Pedro Domínguez Vargas",
    "dependencia": "Secretaria de Bienestar e Inclusión Social del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA165",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-10-01 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "231",
    "servidorPublico": "Greta Pardo Perea",
    "dependencia": "Centro de Justicia para Mujeres del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA027",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-08-01 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "232",
    "servidorPublico": "Alexis Eduardo Flores Estudillo",
    "dependencia": "Autoridad Investigadora de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA011",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-07-24 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "233",
    "servidorPublico": "Rubén Meza Olguín",
    "dependencia": "Colegio de Estudios Cientificos y Tecnológicos del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA387",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-12-19 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "234",
    "servidorPublico": "Eira Rojas Sánchez",
    "dependencia": "Secretaría de Educación Pública del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "30 días",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA088",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-06-24 00:00:00",
    "causaSancion": "Incumplimiento de funciones",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "235",
    "servidorPublico": "José de Jesús Vigueras Santos",
    "dependencia": "Universidad Tecnológica de Tulancingo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA044",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-09-01 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "236",
    "servidorPublico": "Abdiel Vera Vázquez",
    "dependencia": "Universidad de Planeación y Prospectiva",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA056",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-02-26 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "237",
    "servidorPublico": "Karen Lu Yee Carbajal",
    "dependencia": "Universidad de Planeación y Prospectiva",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA086",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-06-06 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "238",
    "servidorPublico": "Maribel Baños del Valle",
    "dependencia": "Universidad de Planeación y Prospectiva",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA048",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2024-09-24 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "239",
    "servidorPublico": "Mario Ferrán Vargas Baños",
    "dependencia": "Universidad de Planeación y Prospectiva",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA049",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2024-09-24 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "240",
    "servidorPublico": "Juan Carlos Peña Chávez",
    "dependencia": "Secretaría Ejecutiva de la Política Pública Estatal",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA64",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-09-01 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "241",
    "servidorPublico": "Margarita Rodríguez Vera",
    "dependencia": "Ssistema para el Desarrollo Integral de la Familia del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA466",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-11-26 00:00:00",
    "causaSancion": "Incumplimiento de funciones",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "242",
    "servidorPublico": "Octavio López Jiménez",
    "dependencia": "Ssistema para el Desarrollo Integral de la Familia del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA382",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-12-19 00:00:00",
    "causaSancion": "Incumplimiento de funciones",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "243",
    "servidorPublico": "Viridiana Leonardo Sedano",
    "dependencia": "Universidad Politécnica de Pachuca",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA195",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-11-24 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "244",
    "servidorPublico": "Armando Pérez Reynoso",
    "dependencia": "Ssistema para el Desarrollo Integral de la Familia del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA185",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-12-15 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "245",
    "servidorPublico": "Valente Martínez Cruz",
    "dependencia": "Comisión de Agua y Alcantarillado de Sistemas Intermunicipales",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA321",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-12-11 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "246",
    "servidorPublico": "Natalia Campos Díaz",
    "dependencia": "Universidad Politécnica de Pachuca",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA223",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-11-25 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "247",
    "servidorPublico": "Luis Alberto Nicolas Martínez",
    "dependencia": "Comisión de Agua y Alcantarillado de Sistemas Intermunicipales",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA363",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-12-19 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "248",
    "servidorPublico": "J. Felix Camargo Sánchez",
    "dependencia": "Colegio de Bachilleres del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA117",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-11-04 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "249",
    "servidorPublico": "Karen Yunuem Vera Valderrama",
    "dependencia": "Oficialia Mayor",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA077",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-09-01 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "250",
    "servidorPublico": "Blanca Estela Zarco Mendoza",
    "dependencia": "Universidad Tecnológica de Tulancingo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA045",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-09-01 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "251",
    "servidorPublico": "Claudia Jocelyn Reyes Hernández",
    "dependencia": "Universidad Tecnológica de Tulancingo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA017",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-09-01 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "252",
    "servidorPublico": "Elizabeth Leyva Barragan",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA0002",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-05-02 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "253",
    "servidorPublico": "Mario de Jesus Martiez Velazquez",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA0004",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-05-02 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "254",
    "servidorPublico": "Octavio Francisco González Ornelas",
    "dependencia": "Secretaria Ejecutiva de la Politica Pública del EStado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA070",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-04-16 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "255",
    "servidorPublico": "Sandra Juarez Chavez",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA0005",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-05-02 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "256",
    "servidorPublico": "Arturo Mejia Cruz",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA0006",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-05-07 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "257",
    "servidorPublico": "Yoheli Yamallel Marquez Reyes",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA007",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-05-07 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "258",
    "servidorPublico": "Raul Martinez Camacho",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA008",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-05-02 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "259",
    "servidorPublico": "Simplicio Ochoa Hernández",
    "dependencia": "Secretaría de Infraestructura Pública y Desarrollo Urbano Sostenible del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA049",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-12-11 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "260",
    "servidorPublico": "Roberto Carlos Jarillo Solano",
    "dependencia": "Comisión de Agua y Alcantarillado de Sistemas Intermunicipales",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA172",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-12-12 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "261",
    "servidorPublico": "Arturo Jesús López Osorio",
    "dependencia": "Comisión de Agua y Alcantarillado de Sistemas Intermunicipales",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA334",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2026-12-15 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "262",
    "servidorPublico": "Julio César Pérez Reyes",
    "dependencia": "Comisión de Agua y Alcantarillado de Sistemas Intermunicipales",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA338",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2026-12-19 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "263",
    "servidorPublico": "Janneth Ortiz Mejia",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA014",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-05-07 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "264",
    "servidorPublico": "Edgar Perez Bautista",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA015",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-05-02 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "265",
    "servidorPublico": "Gladys Perez Cruz",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA016",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-05-02 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "266",
    "servidorPublico": "Sabina Mariel Perez Castillo",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA017",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-05-02 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "267",
    "servidorPublico": "Diana Perez Martinez",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA018",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-05-07 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "268",
    "servidorPublico": "Aleida Percastegui Najera",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA019",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-05-02 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "269",
    "servidorPublico": "Armando Acosta Morales",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA024",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-04-26 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "270",
    "servidorPublico": "Karla Uribe Martinez",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA026",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-04-26 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "271",
    "servidorPublico": "Olaf Angeles Flores",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA027",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-05-02 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "272",
    "servidorPublico": "Nely Sarahid Hernandez Tellez",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA028",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-04-26 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "273",
    "servidorPublico": "Lilia Leticia Ramirez Excelente",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA033",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-05-02 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "274",
    "servidorPublico": "Sandra Ramirez Hernandez",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA034",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-05-02 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "275",
    "servidorPublico": "Elizabeth Reyna Santiago",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA036",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-06-07 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "276",
    "servidorPublico": "Martha Alicia San Juan Butron",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA039",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-04-26 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "277",
    "servidorPublico": "Rodolfo Rangel Ordoñez",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA040",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-05-07 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "278",
    "servidorPublico": "Jose de Jesus Baños Herrera",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA043",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-04-26 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "279",
    "servidorPublico": "Ricardo Alvarado Calderon",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA044",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-04-26 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "280",
    "servidorPublico": "Heriberto Jonatan Baca Morales",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA046",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-04-26 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "281",
    "servidorPublico": "Angel Aaron Melo Rodriguez",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA050",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-05-07 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "282",
    "servidorPublico": "Juan Carlos Baldovino Daniel",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA050",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-05-07 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "283",
    "servidorPublico": "Alejandro Artega Franco",
    "dependencia": "Colegio de Bachilleres del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA097",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2026-01-30 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "284",
    "servidorPublico": "María de la Luz Andrade Aguilera",
    "dependencia": "Colegio de Bachilleres del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA106",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2026-02-27 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "285",
    "servidorPublico": "Fatima Xochiteotzin Trejo Cortés",
    "dependencia": "Colegio de Bachilleres del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA118",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-11-28 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "286",
    "servidorPublico": "Belen Terrazas Galicia",
    "dependencia": "Colegio de Bachilleres del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA156",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2026-01-30 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "287",
    "servidorPublico": "Francisco Antonio Zamora García",
    "dependencia": "Colegio de Bachilleres del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA142",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2026-01-30 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "288",
    "servidorPublico": "Jennifer Dorin Segura Morita",
    "dependencia": "Colegio de Bachilleres del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA160",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-12-12 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "289",
    "servidorPublico": "Imelda Gutierrez Espinoza",
    "dependencia": "Universidad Tecnológica de Tulancingo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA258",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2026-01-30 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "290",
    "servidorPublico": "Sofía Soriano Samperio",
    "dependencia": "Museo Interactivo para la Niñez y la Juventud Hidalguense \"El Rehilete\"",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA380",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2026-02-20 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "291",
    "servidorPublico": "Juan Carlos Baldovino Daniel",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA0055",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-04-26 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "292",
    "servidorPublico": "Kennedy Bautista Valdivia",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA0056",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-04-26 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "293",
    "servidorPublico": "Gloria Vite Nicolas",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA0059",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-05-07 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "294",
    "servidorPublico": "Roberto Allan Velasco Pulido",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA0062",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-04-26 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "295",
    "servidorPublico": "José Arturo Herrera León",
    "dependencia": "Universidad Politécnica de Pachuca",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA178",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2026-02-26 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "296",
    "servidorPublico": "Daniel Garcia Oviedo",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA0065",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-05-07 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "297",
    "servidorPublico": "Claudia Ivette Vite Murillo",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA0066",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-04-26 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "298",
    "servidorPublico": "Luis Garcia Cruz",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA0070",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-04-26 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "299",
    "servidorPublico": "Hilda Fernandez Sanchez",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA0071",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-04-26 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "300",
    "servidorPublico": "Lucio Escudero Pando",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA0072",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-05-07 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "301",
    "servidorPublico": "Manuel Hernández García",
    "dependencia": "Sistema para el Desarrollo Integral de la Familia del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA084",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-12-11 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "302",
    "servidorPublico": "Maribel Cuevas Covarrubias",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA0074",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-05-07 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "303",
    "servidorPublico": "Maria Yared Perez Hernandez",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA0077",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-04-26 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "304",
    "servidorPublico": "Christian Ulisses Campa Sanchez",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA0080",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-04-26 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "305",
    "servidorPublico": "Ana Lizbeth Bautista Lppez",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA0085",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-04-26 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "306",
    "servidorPublico": "Adelina Rangel Pérez",
    "dependencia": "Colegio de Bachilleres del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA127",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-12-19 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "307",
    "servidorPublico": "Sandra Cruz Hernandez",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA0086",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-05-23 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "308",
    "servidorPublico": "Marcos Nathaniel Carpio Santos",
    "dependencia": "Universidad Politécnica de Pachuca",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA229",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2026-02-26 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "309",
    "servidorPublico": "Erika Aleman Godinez",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA0091",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-05-23 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "310",
    "servidorPublico": "Daniela Amanda Mercado Reséndiz",
    "dependencia": "Oficialia Mayor",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA233",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-12-12 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "311",
    "servidorPublico": "Jorge Eduardo Zenteno Ruano",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA0092",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-04-26 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "312",
    "servidorPublico": "Roses Sharon Arciniega Canales",
    "dependencia": "Radio y Televisión de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA347",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2026-02-06 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "313",
    "servidorPublico": "Jesus Eleazar Juarez Contreras",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA0095",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-05-23 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "314",
    "servidorPublico": "Tania Berenice Migueles Barcenas",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA0096",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-05-07 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "315",
    "servidorPublico": "Ramón Tejeda Portillo",
    "dependencia": "Corporación de Fomento de Infraestructura Industrial",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA369",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2026-01-15 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "316",
    "servidorPublico": "Julia Mejia Cruz",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA0097",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-04-26 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "317",
    "servidorPublico": "Nancy Rosario Mendoza Mendoza",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA0098",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2024-04-26 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "318",
    "servidorPublico": "Brenda Ortiz Gomez",
    "dependencia": "Instituto Hidalguense de Educación",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-IHE/2023/PRA0102",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Organo Interno de Control en el Instituto Hidalguense",
    "fechaResolucion": "2025-04-03 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "319",
    "servidorPublico": "Diana Esperanza Olmedo López",
    "dependencia": "Municipio de Tulancingo de Bravo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "MTB/OIC/PRA-041/2025",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control municipal de Tulancingo de Bravo",
    "fechaResolucion": "2026-05-06 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "320",
    "servidorPublico": "José Fernando Lira Pérez",
    "dependencia": "Municipio de Tulancingo de Bravo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "MTB/OIC/PRA-039/2025",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control municipal de Tulancingo de Bravo",
    "fechaResolucion": "2026-05-06 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "321",
    "servidorPublico": "Elizabeth Herrera Riveros",
    "dependencia": "Municipio de Tulancingo de Bravo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "MTB/OIC/PRA-040/2025",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control municipal de Tulancingo de Bravo",
    "fechaResolucion": "2026-05-06 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "322",
    "servidorPublico": "Guillermina Fajardo Rodríguez",
    "dependencia": "Servicios de Salud de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-SSH-SSAH/2024/PRA0053",
    "autoridadSancionadora": "Autoridad Substanciadora Y Resolutora Del Órgano Interno De Control En La Secretaria De Salud Y De Servicios De Salud",
    "fechaResolucion": "2026-03-24 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "323",
    "servidorPublico": "Dulce María Ortíz Cornejo",
    "dependencia": "Servicios de Salud de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-SSH-SSAH/2024/PRA0048",
    "autoridadSancionadora": "Autoridad Substanciadora Y Resolutora Del Órgano Interno De Control En La Secretaria De Salud Y De Servicios De Salud",
    "fechaResolucion": "2026-02-16 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "324",
    "servidorPublico": "Ana Jatzhe Tapia Camargo",
    "dependencia": "Servicios de Salud de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-SSH-SSAH/2024/PRA0042",
    "autoridadSancionadora": "Autoridad Substanciadora Y Resolutora Del Órgano Interno De Control En La Secretaria De Salud Y De Servicios De Salud",
    "fechaResolucion": "2025-09-26 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "325",
    "servidorPublico": "Saira Marlene Gómez Jiménez",
    "dependencia": "Servicios de Salud de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-SSH-SSAH/2025/PRA0020",
    "autoridadSancionadora": "Autoridad Substanciadora Y Resolutora Del Órgano Interno De Control En La Secretaria De Salud Y De Servicios De Salud",
    "fechaResolucion": "2026-02-18 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "326",
    "servidorPublico": "Maribel López Alfaro",
    "dependencia": "Servicios de Salud de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-SSH-SSAH/2024/PRA0041",
    "autoridadSancionadora": "Autoridad Substanciadora Y Resolutora Del Órgano Interno De Control En La Secretaria De Salud Y De Servicios De Salud",
    "fechaResolucion": "2025-09-26 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "327",
    "servidorPublico": "Lilia Marcela Vargas Zaragoza",
    "dependencia": "Servicios de Salud de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC-SSH-SSAH/2024/PRA0039",
    "autoridadSancionadora": "Autoridad Substanciadora Y Resolutora Del Órgano Interno De Control En La Secretaria De Salud Y De Servicios De Salud",
    "fechaResolucion": "2025-09-17 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "328",
    "servidorPublico": "Lizbeth Guerrero Barrera",
    "dependencia": "Municipio de Tepetitlán",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "46174",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno De Control Municipal de Tepetitlán",
    "fechaResolucion": "2026-06-17 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "329",
    "servidorPublico": "José Enrique Mendoza Cruz",
    "dependencia": "Municipio de Tepetitlán",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "46204",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno De Control Municipal de Tepetitlán",
    "fechaResolucion": "2026-06-18 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "330",
    "servidorPublico": "Laura Leticia Elizondo Casillas",
    "dependencia": "Municipio de Tepetitlán",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "46113",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno De Control Municipal de Tepetitlán",
    "fechaResolucion": "2026-06-16 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "331",
    "servidorPublico": "Alexandra Ximena Enriquez Villa",
    "dependencia": "Municipio de Tepetitlán",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "46143",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno De Control Municipal de Tepetitlán",
    "fechaResolucion": "2026-06-16 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "332",
    "servidorPublico": "Pío V. Ramón Baca Borges",
    "dependencia": "Municipio de Tepetitlán",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "23/2025",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno De Control Municipal de Tepetitlán",
    "fechaResolucion": "2026-06-24 00:00:00",
    "causaSancion": "Negligencia Administrativa",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "333",
    "servidorPublico": "Génesis Aline Mendoza Mentado",
    "dependencia": "Universidad Tecnológica de Tulancingo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA351",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2026-06-08 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "334",
    "servidorPublico": "Mario Castillo Velázquez",
    "dependencia": "Secretaría de Gobierno",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA480",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2026-03-30 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "335",
    "servidorPublico": "Jadciri Ramos Sánchez",
    "dependencia": "Comisión de Agua y Alcantarillado de Sistemas Intermunicipales",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA342",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2026-05-29 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "336",
    "servidorPublico": "Yessica Hernández Vázquez",
    "dependencia": "Comisión de Agua y Alcantarillado de Sistemas Intermunicipales",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA358",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2026-05-29 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "337",
    "servidorPublico": "Omar Rodríguez Ramírez",
    "dependencia": "Secretaría de Agricultura y Desarrollo Rural",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA300",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2026-03-31 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "338",
    "servidorPublico": "Karla Ibeth Hernández Hidalgo",
    "dependencia": "Sistema para el Desarrollo Integral de la Familia del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA076",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2026-05-22 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "339",
    "servidorPublico": "Lidia Janett Oliver Balderrama",
    "dependencia": "Universidad Tecnológica de Tulancingo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA370",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2026-03-09 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "340",
    "servidorPublico": "Ernesto Hervert Hernández",
    "dependencia": "Colegio de Bachilleres del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA140",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2026-02-24 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "341",
    "servidorPublico": "Héctor González Rosales",
    "dependencia": "Secretaría de Bienestar e Inclusión Social",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2024/PRA360",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2026-01-30 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "342",
    "servidorPublico": "Luis Ignacio Castillo Montes",
    "dependencia": "Colegio de Bachilleres del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA157",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2026-05-15 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "343",
    "servidorPublico": "Mario Oscar Ordaz Oliver",
    "dependencia": "Universidad Politécnica de Pachuca",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA241",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2026-01-30 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "344",
    "servidorPublico": "Alejandro Almaraz Méndez",
    "dependencia": "Comisión de Agua y Alcantarillado de Sistemas Intermunicipales",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA391",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2026-04-06 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "345",
    "servidorPublico": "Blanca Arcelia Garrido Olvera",
    "dependencia": "Sistema para el Desarrollo Integral de la Familia del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA425",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2026-04-06 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "346",
    "servidorPublico": "Susana Cervantes Morales",
    "dependencia": "Colegio de Bachilleres del Estado de Hidalgo",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA112",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2026-03-27 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "347",
    "servidorPublico": "Luis Enrique Mendoza Trejo",
    "dependencia": "Comisión de Agua y Alcantarillado de Sistemas Intermunicipales",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA394",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2026-04-30 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "348",
    "servidorPublico": "Yazmín Balderas Enriquez",
    "dependencia": "Instituto Hidalguense de las Mujeres",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA385",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2026-04-06 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "349",
    "servidorPublico": "Victor Arturo Bautista Ramírez",
    "dependencia": "Instituto Hidalguense de Educación para Adultos",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "DGR/065/2021",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-02-20 00:00:00",
    "causaSancion": "Incumplimiento de funciones",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "350",
    "servidorPublico": "Alba Isela Godínez León",
    "dependencia": "Sistema DIF del Municipio de Tizayuca",
    "sancion": "Amonestación Pública",
    "duracion": "",
    "expedienteNUC": "OIC/DIF/RES/001/2026",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control del SMDIF del Municipio de Tizayuca",
    "fechaResolucion": "2026-03-06 00:00:00",
    "causaSancion": "Incumplimiento de funciones",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "NaT",
    "fechaFinalSancion": "NaT",
    "anio": "2026"
  },
  {
    "numero": "351",
    "servidorPublico": "Melina Hernández Baños",
    "dependencia": "Centro Estatal de Maquinaria para el Desarrollo del Estado de Hidalgo",
    "sancion": "Inhabilitación",
    "duracion": "11 años",
    "expedienteNUC": "DGR/005/2019",
    "autoridadSancionadora": "Cuarta Sala del Tribunal de Justicia Administrativa del Estado de Hidalgo",
    "fechaResolucion": "2022-07-04 00:00:00",
    "causaSancion": "Desvío de Recursos Públicos",
    "sancionEconomica": "221700.23",
    "fechaInicioSancion": "2024-01-12 00:00:00",
    "fechaFinalSancion": "2035-01-12 00:00:00",
    "anio": "2026"
  },
  {
    "numero": "352",
    "servidorPublico": "Denisse Ordónez Osorio",
    "dependencia": "Centro Estatal de Maquinaria para el Desarrollo del Estado de Hidalgo",
    "sancion": "Inhabilitación",
    "duracion": "12 años",
    "expedienteNUC": "DGR/005/2019",
    "autoridadSancionadora": "Cuarta Sala del Tribunal de Justicia Administrativa del Estado de Hidalgo",
    "fechaResolucion": "2022-07-04 00:00:00",
    "causaSancion": "Desvío de Recursos Públicos",
    "sancionEconomica": "64178.74",
    "fechaInicioSancion": "2024-01-12 00:00:00",
    "fechaFinalSancion": "2036-01-12 00:00:00",
    "anio": "2026"
  },
  {
    "numero": "353",
    "servidorPublico": "Eleazar Eduardo García Sánchez",
    "dependencia": "Ayuntamiento de Pachuca de Soto",
    "sancion": "Inhabilitación",
    "duracion": "3 años 4 meses",
    "expedienteNUC": "157/2024",
    "autoridadSancionadora": "Juez de Control del Distrito Judicial de Pachuca de Soto, Hidalgo",
    "fechaResolucion": "2024-03-06 00:00:00",
    "causaSancion": "Peculado",
    "sancionEconomica": "1227.6",
    "fechaInicioSancion": "2024-03-06 00:00:00",
    "fechaFinalSancion": "2027-07-06 00:00:00",
    "anio": "2026"
  },
  {
    "numero": "354",
    "servidorPublico": "Fernando Reza Saldaña",
    "dependencia": "Secretaría Ejecutiva de Disciplina del Consejo de la Judicatura Federal",
    "sancion": "Inhabilitación",
    "duracion": "10 años",
    "expedienteNUC": "29/2018",
    "autoridadSancionadora": "Secretaría Ejecutiva de Disciplina del Consejo de la Judicatura Federal",
    "fechaResolucion": "2020-01-08 00:00:00",
    "causaSancion": "Ejercicio Indebido de lla Funcion de Magistrado de Circuito",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "2020-02-25 00:00:00",
    "fechaFinalSancion": "2030-02-24 00:00:00",
    "anio": "2026"
  },
  {
    "numero": "355",
    "servidorPublico": "Alejandro Curiel Júarez",
    "dependencia": "Apan",
    "sancion": "Inhabilitación",
    "duracion": "15 años",
    "expedienteNUC": "45627",
    "autoridadSancionadora": "Magistrado Titular de la Tercera Sala del Tribunal de Justicia Administrativa del Poder Judicial del Estado de Hidalgo",
    "fechaResolucion": "2024-09-19 00:00:00",
    "causaSancion": "Desvío de recursos",
    "sancionEconomica": "1230310.0",
    "fechaInicioSancion": "2024-09-19 00:00:00",
    "fechaFinalSancion": "2039-09-19 00:00:00",
    "anio": "2026"
  },
  {
    "numero": "356",
    "servidorPublico": "C. Bernardino Hernández Rodríguez",
    "dependencia": "Presidencia Municipal de Tetepango",
    "sancion": "Inhabilitación",
    "duracion": "10 años",
    "expedienteNUC": "115/2020",
    "autoridadSancionadora": "Magistrado Titular de la Tercera Sala del Tribunal de Justicia Administrativa del Poder Judicial del Estado de Hidalgo",
    "fechaResolucion": "2022-08-15 00:00:00",
    "causaSancion": "Desvío de Recursos",
    "sancionEconomica": "189861.77",
    "fechaInicioSancion": "2022-10-24 00:00:00",
    "fechaFinalSancion": "2032-10-24 00:00:00",
    "anio": "2026"
  },
  {
    "numero": "357",
    "servidorPublico": "Cesia Vega Muñoz",
    "dependencia": "Secretaría de Gobierno",
    "sancion": "Inhabilitación",
    "duracion": "10 años",
    "expedienteNUC": "171/2023",
    "autoridadSancionadora": "MAGISTRADA TITULAR DE LA SEGUNDA SALA DEL TRIBUNAL DE JUSTICIA ADMINISTRATIVA DEL PODER JUDICIAL DEL ESTADO DE HIDALGO",
    "fechaResolucion": "2022-03-08 00:00:00",
    "causaSancion": "Negligencia Administrativa",
    "sancionEconomica": "116000.0",
    "fechaInicioSancion": "2023-08-15 00:00:00",
    "fechaFinalSancion": "2033-08-15 00:00:00",
    "anio": "2026"
  },
  {
    "numero": "358",
    "servidorPublico": "José de Jesús Gómez García",
    "dependencia": "Comisión de Agua y Alcantarillado del municipio de Tizayuca",
    "sancion": "Inhabilitación",
    "duracion": "1 año",
    "expedienteNUC": "OIC-CAAMTH/RES/2023/03",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control de la Comisión de Agua y Alcantarillado del municipio de Tizayuca",
    "fechaResolucion": "2025-03-03 00:00:00",
    "causaSancion": "Incumplimiento de funciones",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "2026-02-20 00:00:00",
    "fechaFinalSancion": "2027-02-22 00:00:00",
    "anio": "2026"
  },
  {
    "numero": "359",
    "servidorPublico": "Sergio Abinadab Soto Hernández",
    "dependencia": "Comisión de Agua y Alcantarillado del municipio de Tizayuca",
    "sancion": "Inhabilitación",
    "duracion": "1 año",
    "expedienteNUC": "OIC-CAAMTH/RES/2023/02",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control de la Comisión de Agua y Alcantarillado del municipio de Tizayuca",
    "fechaResolucion": "2025-01-20 00:00:00",
    "causaSancion": "Violación a Leyes y Normatividad Presupuestal",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "2026-06-03 00:00:00",
    "fechaFinalSancion": "2027-06-03 00:00:00",
    "anio": "2026"
  },
  {
    "numero": "360",
    "servidorPublico": "Sergio Abinadab Soto Hernández",
    "dependencia": "Comisión de Agua y Alcantarillado del municipio de Tizayuca",
    "sancion": "Inhabilitación",
    "duracion": "1 año",
    "expedienteNUC": "OIC-CAAMTH/RES/2023/03",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control de la Comisión de Agua y Alcantarillado del municipio de Tizayuca",
    "fechaResolucion": "2025-01-20 00:00:00",
    "causaSancion": "Violación a Leyes y Normatividad Presupuestal",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "2027-06-04 00:00:00",
    "fechaFinalSancion": "2028-06-05 00:00:00",
    "anio": "2026"
  },
  {
    "numero": "361",
    "servidorPublico": "Sergio Abinadab Soto Hernández",
    "dependencia": "Comisión de Agua y Alcantarillado del municipio de Tizayuca",
    "sancion": "Inhabilitación",
    "duracion": "1 año",
    "expedienteNUC": "OIC-CAAMTH/RES/2023/04",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control de la Comisión de Agua y Alcantarillado del municipio de Tizayuca",
    "fechaResolucion": "2025-06-06 00:00:00",
    "causaSancion": "Violación a Leyes y Normatividad Presupuestal",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "2028-06-06 00:00:00",
    "fechaFinalSancion": "2029-06-06 00:00:00",
    "anio": "2026"
  },
  {
    "numero": "362",
    "servidorPublico": "José de Jesús Gómez García",
    "dependencia": "Comisión de Agua y Alcantarillado del municipio de Tizayuca",
    "sancion": "Inhabilitación",
    "duracion": "1 año",
    "expedienteNUC": "OIC-CAAMTH/RES/2023/05",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control de la Comisión de Agua y Alcantarillado del municipio de Tizayuca",
    "fechaResolucion": "2025-08-04 00:00:00",
    "causaSancion": "Violación de leyes y normatividad presupuestal",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "2027-02-23 00:00:00",
    "fechaFinalSancion": "2028-02-23 00:00:00",
    "anio": "2026"
  },
  {
    "numero": "363",
    "servidorPublico": "Sergio Abinadab Soto Hernández",
    "dependencia": "Comisión de Agua y Alcantarillado del municipio de Tizayuca",
    "sancion": "Inhabilitación",
    "duracion": "1 año",
    "expedienteNUC": "OIC-CAAMTH/RES/2023/06",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control de la Comisión de Agua y Alcantarillado del municipio de Tizayuca",
    "fechaResolucion": "2025-10-24 00:00:00",
    "causaSancion": "Violación a Leyes y Normatividad Presupuestal",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "2028-06-07 00:00:00",
    "fechaFinalSancion": "2030-06-07 00:00:00",
    "anio": "2026"
  },
  {
    "numero": "364",
    "servidorPublico": "José de Jesús Gómez García",
    "dependencia": "Comisión de Agua y Alcantarillado del municipio de Tizayuca",
    "sancion": "Inhabilitación",
    "duracion": "1 año",
    "expedienteNUC": "OIC-CAAMTH/RES/2023/06",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control de la Comisión de Agua y Alcantarillado del municipio de Tizayuca",
    "fechaResolucion": "2025-10-24 00:00:00",
    "causaSancion": "Violación a Leyes y Normatividad Presupuestal",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "2028-02-24 00:00:00",
    "fechaFinalSancion": "2029-02-26 00:00:00",
    "anio": "2026"
  },
  {
    "numero": "365",
    "servidorPublico": "Hillary Vanessa Rodriguez Sánchez.",
    "dependencia": "Municipio de Atotonilco de Tula",
    "sancion": "Inhabilitación",
    "duracion": "8 meses",
    "expedienteNUC": "PMAT/CIM/PRA/04/2025",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora del Órgano Interno de Contro Municipal de Atotonilco de Tula",
    "fechaResolucion": "2025-10-13 00:00:00",
    "causaSancion": "Negligencia Administrativa",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "2025-12-10 00:00:00",
    "fechaFinalSancion": "2026-08-10 00:00:00",
    "anio": "2026"
  },
  {
    "numero": "366",
    "servidorPublico": "Jazmín Arredondo Hernández",
    "dependencia": "Municipio de Tula de Allende",
    "sancion": "Inhabilitación",
    "duracion": "1 año",
    "expedienteNUC": "PMTAEH/OIC/PRA/AS/01/2025",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control Municipal de Tula de Allende",
    "fechaResolucion": "2025-11-20 00:00:00",
    "causaSancion": "Negligencia Administrativa",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "2025-12-16 00:00:00",
    "fechaFinalSancion": "2026-12-16 00:00:00",
    "anio": "2026"
  },
  {
    "numero": "367",
    "servidorPublico": "Ignacio Valdez Benítez",
    "dependencia": "Servicios de Salud Hidalgo",
    "sancion": "Inhabilitación",
    "duracion": "-",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA393",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-12-02 00:00:00",
    "causaSancion": "Incumplimiento de funciones",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "2026-01-26 00:00:00",
    "fechaFinalSancion": "2027-01-26 00:00:00",
    "anio": "2026"
  },
  {
    "numero": "368",
    "servidorPublico": "Delia Jessica Blancas Hidalgo",
    "dependencia": "Secretaría de Finanzas Púbicas",
    "sancion": "Inhabilitación",
    "duracion": "-",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA390",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-12-02 00:00:00",
    "causaSancion": "Incumplimiento de funciones",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "2026-01-26 00:00:00",
    "fechaFinalSancion": "2027-01-26 00:00:00",
    "anio": "2026"
  },
  {
    "numero": "369",
    "servidorPublico": "Juan Luis García Hernández",
    "dependencia": "Secretaría de Finanzas Púbicas",
    "sancion": "Inhabilitación",
    "duracion": "-",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA390",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-12-02 00:00:00",
    "causaSancion": "Incumplimiento de funciones",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "2026-01-26 00:00:00",
    "fechaFinalSancion": "2027-01-26 00:00:00",
    "anio": "2026"
  },
  {
    "numero": "370",
    "servidorPublico": "César Alberto González López",
    "dependencia": "Secretaría de Finanzas Púbicas",
    "sancion": "Inhabilitación",
    "duracion": "-",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA390",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2025-12-02 00:00:00",
    "causaSancion": "Incumplimiento de funciones",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "2026-01-26 00:00:00",
    "fechaFinalSancion": "2027-01-26 00:00:00",
    "anio": "2026"
  },
  {
    "numero": "371",
    "servidorPublico": "Adriana Pérez López",
    "dependencia": "Muncipio de Atotonilco de Tula",
    "sancion": "Inhabilitación",
    "duracion": "1 año",
    "expedienteNUC": "PMAT/CIM/PRA/04/2024",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control municipal de Atotonilco de Tula",
    "fechaResolucion": "2024-09-25 00:00:00",
    "causaSancion": "Omisión a realizar su entrega recepción en tiempo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "2026-02-12 00:00:00",
    "fechaFinalSancion": "2027-02-12 00:00:00",
    "anio": "2026"
  },
  {
    "numero": "372",
    "servidorPublico": "Yamilet Monserrat Fuentes López",
    "dependencia": "Muncipio de Atotonilco de Tula",
    "sancion": "Inhabilitación",
    "duracion": "6 meses",
    "expedienteNUC": "PMAT/CIM/PRA/07/2025",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control municipal de Atotonilco de Tula",
    "fechaResolucion": "2025-11-18 00:00:00",
    "causaSancion": "Omisión a realizar su entrega recepción en tiempo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "2026-02-12 00:00:00",
    "fechaFinalSancion": "2026-08-12 00:00:00",
    "anio": "2026"
  },
  {
    "numero": "373",
    "servidorPublico": "Lizbeth Sánchez Estrada",
    "dependencia": "Municipio de Atotonilco de Tula",
    "sancion": "Inhabilitación",
    "duracion": "6 meses",
    "expedienteNUC": "PMAT/CIM/PRA/06/2025",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control municipal de Atotonilco de Tula",
    "fechaResolucion": "2025-11-11 00:00:00",
    "causaSancion": "Omisión a realizar su entrega recepción en tiempo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "2026-03-19 00:00:00",
    "fechaFinalSancion": "2026-09-19 00:00:00",
    "anio": "2026"
  },
  {
    "numero": "374",
    "servidorPublico": "Luz Elena Cadena Ávila",
    "dependencia": "Municipio de Tulancingo de Bravo",
    "sancion": "Inhabilitación",
    "duracion": "6 meses",
    "expedienteNUC": "MTB/OIC/PRA-032/2025",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control municipal de Tulancingo de Bravo",
    "fechaResolucion": "2026-02-25 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "2026-03-21 00:00:00",
    "fechaFinalSancion": "2026-09-16 00:00:00",
    "anio": "2026"
  },
  {
    "numero": "375",
    "servidorPublico": "Alfredo García Hernández",
    "dependencia": "Municipio de Tulancingo de Bravo",
    "sancion": "Inhabilitación",
    "duracion": "6 meses",
    "expedienteNUC": "MTB/OIC/PRA-033/2025",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control municipal de Tulancingo de Bravo",
    "fechaResolucion": "2026-02-25 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "2026-03-21 00:00:00",
    "fechaFinalSancion": "2026-09-16 00:00:00",
    "anio": "2026"
  },
  {
    "numero": "376",
    "servidorPublico": "María de la Luz Vargas Escobedo",
    "dependencia": "Municipio de Tulancingo de Bravo",
    "sancion": "Inhabilitación",
    "duracion": "6 meses",
    "expedienteNUC": "MTB/OIC/PRA-035/2025",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control municipal de Tulancingo de Bravo",
    "fechaResolucion": "2026-02-25 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "2026-03-21 00:00:00",
    "fechaFinalSancion": "2026-09-16 00:00:00",
    "anio": "2026"
  },
  {
    "numero": "377",
    "servidorPublico": "Dante Heron Refugio Flores",
    "dependencia": "Municipio de Tulancingo de Bravo",
    "sancion": "Inhabilitación",
    "duracion": "9 meses",
    "expedienteNUC": "MTB/OIC/PRA-034/2025",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control municipal de Tulancingo de Bravo",
    "fechaResolucion": "2026-02-25 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "2026-03-21 00:00:00",
    "fechaFinalSancion": "2026-12-20 00:00:00",
    "anio": "2026"
  },
  {
    "numero": "378",
    "servidorPublico": "María Rocio Orduña Morales",
    "dependencia": "Muncipio de Tulancingo de Bravo",
    "sancion": "Inhabilitación",
    "duracion": "3 meses",
    "expedienteNUC": "MTB/OIC/PRA-037/2025",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control municipal de Tulancingo de Bravo",
    "fechaResolucion": "2026-02-11 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "2026-04-10 00:00:00",
    "fechaFinalSancion": "2026-07-13 00:00:00",
    "anio": "2026"
  },
  {
    "numero": "379",
    "servidorPublico": "Ariana Monserrat González Viagres",
    "dependencia": "Sistema para el Desarrollo Integral de la Familia del Estado de Hidalgo",
    "sancion": "Inhabilitación",
    "duracion": "4 meses",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA075",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2026-07-10 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "2025-08-14 00:00:00",
    "fechaFinalSancion": "2026-12-14 00:00:00",
    "anio": "2026"
  },
  {
    "numero": "380",
    "servidorPublico": "Valentín Santiago Velázquez",
    "dependencia": "Colegio de Estudios Cientificos y Tecnológicos del Estado de Hidalgo",
    "sancion": "Inhabilitación",
    "duracion": "4 meses",
    "expedienteNUC": "SC/DGRA/DR/2025/PRA024",
    "autoridadSancionadora": "Autoridad Substanciadora y Resolutora de Faltas Administrativas de la Dirección General de Responsabilidades Administrativas de la Secretaría de Contraloría del Estado de Hidalgo",
    "fechaResolucion": "2026-03-02 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "2026-04-10 00:00:00",
    "fechaFinalSancion": "2026-08-10 00:00:00",
    "anio": "2026"
  },
  {
    "numero": "381",
    "servidorPublico": "Blanca Esthela Camargo Angeles",
    "dependencia": "Municipio de Tetepango",
    "sancion": "Inhabilitación",
    "duracion": "6 meses",
    "expedienteNUC": "PRA-0001/OIC-TETE/2025",
    "autoridadSancionadora": "Titular de la Unidad Substanciadora y Resolutora del Órgano Interno de Control Municipal de Tetepango",
    "fechaResolucion": "2025-12-04 00:00:00",
    "causaSancion": "Incumplimiento a la declaración patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "2026-03-24 00:00:00",
    "fechaFinalSancion": "2026-09-24 00:00:00",
    "anio": "2026"
  },
  {
    "numero": "382",
    "servidorPublico": "Ericka Mendoza Limón",
    "dependencia": "Municipio de Tulancingo de Bravo",
    "sancion": "Inhabilitación",
    "duracion": "6 meses",
    "expedienteNUC": "MTB/OIC/PRA-036/2025",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control municipal de Tulancingo de Bravo",
    "fechaResolucion": "2026-02-11 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "2026-04-10 00:00:00",
    "fechaFinalSancion": "2026-08-12 00:00:00",
    "anio": "2026"
  },
  {
    "numero": "383",
    "servidorPublico": "Marian Alejandra Tovar Angeles",
    "dependencia": "Municipio de Atotonilco de Tula",
    "sancion": "Inhabilitación",
    "duracion": "6 meses",
    "expedienteNUC": "PMAT/CIM/PRA/09/2025",
    "autoridadSancionadora": "Autoridad Resolutora del Órgano Interno de Control municipal de Atotonilco de Tula",
    "fechaResolucion": "2026-01-07 00:00:00",
    "causaSancion": "Omisión a realizar su entrega recepción en tiempo",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "2026-04-15 00:00:00",
    "fechaFinalSancion": "2026-10-15 00:00:00",
    "anio": "2026"
  },
  {
    "numero": "384",
    "servidorPublico": "Blanca Esthela Camargo Ángeles",
    "dependencia": "Municipio de Tetepango",
    "sancion": "Inhabilitación",
    "duracion": "6 meses",
    "expedienteNUC": "PRA-0001/OIC-TETE/2025",
    "autoridadSancionadora": "Titular de la Unidad Substanciadora y Resolutora del Órgano Interno de Control municipal de Tetepango",
    "fechaResolucion": "2025-12-04 00:00:00",
    "causaSancion": "Incumplimiento a la Declaración Patrimonial",
    "sancionEconomica": "0.0",
    "fechaInicioSancion": "2026-03-24 00:00:00",
    "fechaFinalSancion": "2026-09-24 00:00:00",
    "anio": "2026"
  }
];
